import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import * as React from 'react';

const cardStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1.375rem;
	border-radius: ${theme.radii.xlarge};
	background-color: ${theme.colors.surface};
	border: 1.5px solid ${theme.colors.border};
`;

const headStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.375rem;
`;

const titleStyle = css`
	${theme.typography.cardTitle}
	margin: 0;
	font-size: 1.375rem;
	line-height: 1.2;
	letter-spacing: -0.02em;
	color: ${theme.colors.ink};
`;

const numberStyle = css`
	color: ${theme.colors.accent};
`;

const hintStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: 0.78125rem;
	line-height: 1.55;
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly number: number;
	readonly title: string;
	readonly hint: string;
	readonly children: React.ReactNode;
};

/** A numbered section of the preparation screen: a white card with its title, a one-line hint and its content. */
const PreparationCard: React.FC<Props> = ({ number, title, hint, children }) => {
	const titleId = React.useId();

	return (
		<section css={cardStyle} aria-labelledby={titleId}>
			<div css={headStyle}>
				<h2 id={titleId} css={titleStyle}>
					<span css={numberStyle}>{number}.</span> {title}
				</h2>
				<p css={hintStyle}>{hint}</p>
			</div>
			{children}
		</section>
	);
};

export default PreparationCard;
